/**
 * Check if birth date exceeds the minimum to prevent unrealistic birth dates
 * @param  {String} value - input value: date (format: 01-02-1993)
 * @param {Object} options - message - feedback message
 * @returns {String|null} returns null which validates as true in validate.js or an error string
 */
const minAge = function (value, options) {
  if (!value || !options.message) return null

  const [day, month, year] = value.split('-')

  if (!day || !month || !year) return null

  const birthDate = new Date(+year, month - 1, +day)
  const age = new Date() - birthDate

  // Check if age is older dan 120 years
  if (!birthDate || age > 120 * 365 * 24 * 60 * 60 * 1000) return options.message

  return null
}

export default minAge
